import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
interface HallmarkSlide7Props {
  isDark?: boolean;
}
export function HallmarkSlide7({
  isDark = false
}: HallmarkSlide7Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const paths = ['Expand to additional leadership waves', 'Roll out within a high-change division', 'Integrate into annual leadership wellness strategy', 'Continue with deeper reporting and expanded access'];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-114">
      <div className="min-h-full flex flex-col justify-center max-w-5xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-115">
        {/* Header */}
        <motion.div variants={itemVariants} className="text-center mb-12 sm:mb-16" data-id="element-116">
          <h1 className={`text-3xl sm:text-5xl font-serif font-medium mb-4 sm:mb-6 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-117">
            Day 90: Clear Next Step
          </h1>
        </motion.div>

        {/* Decision Paths */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-16" data-id="element-118">
          {paths.map((path, idx) => <motion.div key={idx} variants={itemVariants} className={`rounded-2xl p-6 sm:p-8 flex items-start gap-4 shadow-sm hover:shadow-md transition-all duration-300 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige'}`} data-id="element-119">
              <div className={`mt-1 p-1.5 rounded-full flex-shrink-0 ${isDark ? 'bg-heliona-mint/20' : 'bg-heliona-mint/10'}`} data-id="element-120">
                <ArrowRight className={`w-5 h-5 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-121" />
              </div>
              <p className={`text-lg font-medium leading-relaxed ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-122">
                {path}
              </p>
            </motion.div>)}
        </div>

        {/* Closing Statement */}
        <motion.div variants={itemVariants} className="text-center" data-id="element-123">
          <div className={`inline-block rounded-3xl p-8 sm:p-10 max-w-3xl mx-auto ${isDark ? 'bg-heliona-navy/30 border border-heliona-navy/50' : 'bg-heliona-navy/5 border border-heliona-navy/10'}`} data-id="element-124">
            <p className={`text-xl sm:text-2xl font-serif italic leading-relaxed ${isDark ? 'text-white/90' : 'text-heliona-charcoal'}`} data-id="element-125">
              "This is not about solving everything in 90 days. It's about
              building leadership wellness during change."
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}